import Legenda  from '../../../assets/legend-primary.svg?react'
import Close  from '../../../assets/close.svg?react'
import MonumentoNoFoto  from '../../../assets/monumento-no-foto.svg?react'
import Monumento1a10  from '../../../assets/monumento-1a10.svg?react'
import MonumentoMaggiore10  from '../../../assets/monumento-maggiore-10.svg?react'
import MonumentoConcorso  from '../../../assets/concorso.svg?react'
import MonumentoNoConcorso  from '../../../assets/no-concorso.svg?react'
import styles from './Legend.module.css'
import { useTranslation } from 'react-i18next'
import { getActiveGeocontext } from '../../../utils'

interface Props {
  legend: boolean
  setLegend: (legend: boolean) => void
}

export default function Legend({ legend, setLegend }: Props) {
  const { t } = useTranslation()
  const activeGeocontext = getActiveGeocontext()
  return (
    <div className={styles.Legend}>
      <div className={styles.TopLegend}>
        <div className={styles.LegendaLabel}>
          <Legenda fill="var(--primary)" />
          <span className="ms-2">{t('GENERIC_LEGEND')}</span>
        </div>
        <div className="pointer">
          <Close onClick={() => setLegend(false)} />
        </div>
      </div>
      <div className={styles.CardCategorie}>
        <div className={styles.TitleCategorie}>
          {t('LEG_BOX_CATEGORY_TITLE')}
        </div>
        <div className={styles.DescCategorie}>
          {t('LEG_BOX_CATEGORY_TEXT')}
        </div>
        {activeGeocontext?.app_categories.map((category) => (
          <div key={category.id} className={styles.ItemCard}>
            <img
              src={category.icon.icon_color}
              alt={category.name}
              width={13}
              height={13}
            />
            <span className={styles.NameItem}>{t(category.translation)}</span>
          </div>
        ))}
      </div>
      <div className={styles.CardColori}>
        <div className={styles.TitleCategorie}>
          {t('LEG_BOX_COLOR_TITLE')}
        </div>
        <div className={styles.DescCategorie}>
          {t('LEG_BOX_COLOR_TEXT_1')}
        </div>
        <div className={styles.ItemCard}>
          <MonumentoNoFoto />
          <span className={styles.NameItem}>
            {t('LEG_BOX_NUMBER_0_NONE')}
          </span>
        </div>
        <div className={styles.ItemCard}>
          <Monumento1a10 />
          <span className={styles.NameItem}>
            {t('LEG_BOX_NUMBER_1_FEW')}
          </span>
        </div>
        <div className={styles.ItemCard}>
          <MonumentoMaggiore10 />
          <span className={styles.NameItem}>
            {t('LEG_BOX_NUMBER_9_MANY')}
          </span>
        </div>
      </div>
      <div className={styles.CardConcorso}>
        <div className={styles.DescCategorie}>
          {t('LEG_BOX_COLOR_TEXT_2')}
        </div>
        <div className={styles.ItemCard}>
          <MonumentoConcorso />
          <span className={styles.NameItem}>
            {t('LEG_BOX_IN_CONTEST')}
          </span>
        </div>
        <div className={styles.ItemCard}>
          <MonumentoNoConcorso />
          <span className={styles.NameItem}>
            {t('LEG_BOX_OUT_CONTEST')}
          </span>
        </div>
      </div>
    </div>
  )
}
